class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);


/* Zerone: no visible Availability filter. Any size filter automatically means "in stock in that size"
   (Shopify matches variant filters on the same variant, so size=M + availability=1 = M in stock). */
(function () {
  const AV = 'filter.v.availability', SIZE = 'filter.v.option.size';
  const normalize = (qs) => {
    const p = new URLSearchParams(qs || '');
    p.delete(AV);
    if (p.has(SIZE)) p.set(AV, '1');
    return p.toString();
  };
  const orig = FacetFiltersForm.renderPage;
  FacetFiltersForm.renderPage = function (searchParams, event, updateURLHash = true) {
    return orig.call(this, normalize(searchParams), event, updateURLHash);
  };
  const cur = window.location.search.slice(1), fixed = normalize(cur);
  if (fixed !== new URLSearchParams(cur).toString()) {
    window.location.replace(window.location.pathname + (fixed ? '?' + fixed : ''));
  }
})();

/* Zerone: size filter shows only XS / S / M / L / XL / 2XL. Raw values like "XL (Pre-order...)" or
   "L (Fits M-L)" are grouped under their base size; "S/M" belongs to both S and M. The real
   checkboxes stay in the form (hidden), so the URL still carries Shopify's raw values. */
(function () {
  const SIZE = 'filter.v.option.size';
  const ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  const groupsOf = (v) => v.split('(')[0].trim().split('/').map((s) => s.trim().toUpperCase()).filter(Boolean);
  const activeGroups = (raw) => new Set(raw.filter((v) => groupsOf(v).length === 1).map((v) => groupsOf(v)[0]));
  const rank = (g) => (ORDER.indexOf(g) === -1 ? 99 : ORDER.indexOf(g));

  function groupList(list) {
    const inputs = [...list.querySelectorAll(`input[name="${SIZE}"]`)];
    if (!inputs.length || list.dataset.zsize === '1') return;
    list.dataset.zsize = '1';
    const groups = {};
    inputs.forEach((i) => groupsOf(i.value).forEach((g) => (groups[g] = groups[g] || []).push(i)));
    const reps = {};
    Object.keys(groups).forEach((g) => {
      const m = groups[g];
      reps[g] = m.find((i) => groupsOf(i.value).length === 1 && !i.disabled) || m.find((i) => groupsOf(i.value).length === 1) || m[0];
    });
    const repSet = new Set(Object.values(reps));
    inputs.forEach((i) => { if (!repSet.has(i)) i.closest('li').style.display = 'none'; });
    Object.entries(reps).sort((a, b) => rank(a[0]) - rank(b[0])).forEach(([g, i]) => {
      const li = i.closest('li');
      li.style.display = '';
      list.appendChild(li);
      const lab = li.querySelector('label > span[aria-hidden="true"]'); if (lab) lab.textContent = g;
      const vh = li.querySelector('.visually-hidden'); if (vh) vh.textContent = 'Size ' + g;
      const anyActive = groups[g].some((x) => x.checked && groupsOf(x.value).length === 1), anyEnabled = groups[g].some((x) => !x.disabled);
      i.checked = anyActive; i.disabled = !anyEnabled;
      li.querySelector('label').classList.toggle('facet-checkbox--disabled', !anyEnabled);
      li.querySelector('label').classList.toggle('mobile-facets__label--disabled', !anyEnabled);
      i.dataset.zgroup = g;
    });
    list.addEventListener('input', (e) => {
      if (!e.target.dataset || !e.target.dataset.zgroup) return;
      const active = new Set(Object.entries(reps).filter(([, r]) => r.checked).map(([g]) => g));
      inputs.forEach((x) => { if (!repSet.has(x)) x.checked = groupsOf(x.value).some((g) => active.has(g)); });
    }, true);
  }

  function groupPills() {
    const params = new URLSearchParams(window.location.search);
    const raw = params.getAll(SIZE);
    if (!raw.length) return;
    const active = activeGroups(raw);
    document.querySelectorAll('.active-facets').forEach((box) => {
      const seen = new Set();
      box.querySelectorAll('a.active-facets__button').forEach((a) => {
        if (a.dataset.zdone) { if (a.dataset.zdone !== 'hide') seen.add(a.dataset.zdone); return; }
        const inner = a.querySelector('.active-facets__button-inner'); if (!inner) return;
        const txt = inner.childNodes[0] ? inner.childNodes[0].textContent.trim() : '';
        const v = raw.find((r) => txt.endsWith(': ' + r)); if (!v) return;
        const gs = groupsOf(v); const g = gs[0];
        if (gs.length > 1 || seen.has(g)) { a.dataset.zdone = 'hide'; a.closest('facet-remove').style.display = 'none'; return; }
        seen.add(g); a.dataset.zdone = g;
        inner.childNodes[0].textContent = txt.slice(0, txt.length - v.length) + g + ' ';
        const keep = new Set([...active].filter((x) => x !== g));
        const p = new URLSearchParams(window.location.search);
        p.delete(SIZE);
        raw.filter((r) => groupsOf(r).some((x) => keep.has(x))).forEach((r) => p.append(SIZE, r));
        a.href = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
      });
    });
  }

  function fixCounts() {
    const raw = new URLSearchParams(window.location.search).getAll(SIZE);
    const n = activeGroups(raw).size;
    document.querySelectorAll('details').forEach((d) => {
      if (!d.querySelector(`input[name="${SIZE}"]`)) return;
      d.querySelectorAll('.facets__selected').forEach((el) => { const t = n + ' selected'; if (el.textContent.trim() !== t) el.textContent = t; });
      const sum = d.querySelector('summary');
      if (sum && sum.getAttribute('aria-label')) sum.setAttribute('aria-label', n ? `Size (${n} selected)` : 'Size');
    });
  }

  function apply() {
    fixCounts();
    document.querySelectorAll('ul.facets__list, ul.mobile-facets__list').forEach(groupList);
    groupPills();
  }
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(apply, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();

/* Zerone: infinite scroll on collection pages. Loads the next page of products when the
   shopper nears the bottom, appends them to the grid, and hides the page numbers.
   Re-arms itself after filters/sort re-render the grid. Falls back to normal paging without JS. */
(function () {
  if (!/\/collections\//.test(location.pathname)) return;
  let loading = false, io;
  function nextUrl(root) { const a = (root || document).querySelector('.pagination a[aria-label="Next page"]'); return a ? a.getAttribute('href') : null; }
  function arm() {
    const grid = document.getElementById('product-grid'); const pag = document.querySelector('.pagination-wrapper');
    if (!grid || !pag) return;
    if (pag.dataset.zinf) return; pag.dataset.zinf = '1';
    pag.style.display = 'none';
    let sentinel = document.getElementById('zinf-sentinel');
    if (!sentinel) { sentinel = document.createElement('div'); sentinel.id = 'zinf-sentinel'; sentinel.style.cssText = 'display:block;height:1px;overflow:hidden'; sentinel.innerHTML = '&nbsp;'; }
    grid.insertAdjacentElement('afterend', sentinel);
    if (io) io.disconnect();
    io = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading) return;
      const url = nextUrl(document); if (!url) { io.disconnect(); return; }
      loading = true; sentinel.innerHTML = '<p style="text-align:center;font-size:1.2rem;letter-spacing:.2em;text-transform:uppercase;color:#9a7f8b;padding:2rem 0">Loading more</p>'; sentinel.style.height = 'auto';
      try {
        const html = await (await fetch(url, { credentials: 'same-origin' })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('#product-grid > li');
        const g = document.getElementById('product-grid');
        items.forEach((li) => g.appendChild(document.importNode(li, true)));
        const newPag = doc.querySelector('.pagination-wrapper');
        const curPag = document.querySelector('.pagination-wrapper');
        if (newPag && curPag) curPag.innerHTML = newPag.innerHTML; else if (curPag) curPag.innerHTML = '';
      } catch (e) { io.disconnect(); if (pag) pag.style.display = ''; }
      sentinel.innerHTML = '&nbsp;'; sentinel.style.height = '1px'; loading = false;
      if (!nextUrl(document)) io.disconnect();
    }, { rootMargin: '900px 0px' });
    io.observe(sentinel);
  }
  // filters/sort swap the grid section; re-arm on every change
  new MutationObserver(() => { const pag = document.querySelector('.pagination-wrapper'); if (pag && !pag.dataset.zinf) arm(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();
